import React from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box, Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import AiTemplateArrayInput from './AiTemplateArrayInput'

const ProductDetailsSection = ({ control }) => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
              {t('mailTemplate.campaigns.modal.matchKeywords')}
            </Typography>
            <Controller
              name="productListOp"
              control={control}
              render={({ field: { value, onChange } }) => (
                <ToggleButtonGroup
                  value={value || 'or'}
                  exclusive
                  onChange={(_, newValue) => {
                    if (newValue !== null) {
                      onChange(newValue)
                    }
                  }}
                  size="small"
                  sx={{
                    '& .MuiToggleButton-root': {
                      px: 1.5,
                      py: 0.25,
                      fontSize: '0.7rem',
                      textTransform: 'none',
                      borderColor: 'divider',
                      '&.Mui-selected': {
                        backgroundColor: 'primary.main',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: 'primary.dark'
                        }
                      }
                    }
                  }}
                >
                  <ToggleButton value="or">
                    {t('mailTemplate.campaigns.modal.matchAny')}
                  </ToggleButton>
                  <ToggleButton value="and">
                    {t('mailTemplate.campaigns.modal.matchAll')}
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
            />
          </Box>
          <Controller
            name="productName"
            control={control}
            render={({ field: { value = [], onChange } }) => (
              <AiTemplateArrayInput
                label={t('mailTemplate.campaigns.modal.productName')}
                placeholder={t('mailTemplate.campaigns.modal.productNameP')}
                items={value}
                required={true}
                onAdd={(newValue) => {
                  if (newValue.trim()) {
                    onChange([...value, { value: newValue.trim() }])
                  }
                }}
                onRemove={(index) => {
                  const newValue = [...value]
                  newValue.splice(index, 1)
                  onChange(newValue)
                }}
              />
            )}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default ProductDetailsSection
